export const site = {
  name: "火影同人动漫",
  shortName: "火影同人",
  slogan: "追更不迷路",
  description:
    "汇集穿越、系统、重生、日常、战斗等各类火影同人作品，按剧情类型整理分类，快速找到对味的火影同人动漫。",
  email: "contact@naruto-fan.example",
};